/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1);
const _hoisted_3 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_4 = {
  cellspacing: "0",
  style: {
    "width": "100%"
  }
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "Redis版本")], -1);
const _hoisted_6 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_7 = {
  key: 0,
  class: "cell"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "运行模式")], -1);
const _hoisted_9 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_10 = {
  key: 0,
  class: "cell"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "端口")], -1);
const _hoisted_12 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_13 = {
  key: 0,
  class: "cell"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "客户端数")], -1);
const _hoisted_15 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_16 = {
  key: 0,
  class: "cell"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "运行时间(天)")], -1);
const _hoisted_18 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_19 = {
  key: 0,
  class: "cell"
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "使用内存")], -1);
const _hoisted_21 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_22 = {
  key: 0,
  class: "cell"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "使用CPU")], -1);
const _hoisted_24 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_25 = {
  key: 0,
  class: "cell"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "内存配置")], -1);
const _hoisted_27 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_28 = {
  key: 0,
  class: "cell"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "AOF是否开启")], -1);
const _hoisted_30 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_31 = {
  key: 0,
  class: "cell"
};
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "RDB是否成功")], -1);
const _hoisted_33 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_34 = {
  key: 0,
  class: "cell"
};
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "Key数量")], -1);
const _hoisted_36 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_37 = {
  key: 0,
  class: "cell"
};
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", {
  class: "el-table__cell is-leaf"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "cell"
}, "网络入口/出口")], -1);
const _hoisted_39 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_40 = {
  key: 0,
  class: "cell"
};
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "命令统计", -1);
const _hoisted_42 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "内存信息", -1);
const _hoisted_44 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
import { getCache } from '@/api/monitor/cache';
import * as echarts from 'echarts';
export default {
  __name: 'index',
  setup(__props) {
    const cache = ref([]);
    const commandstats = ref(null);
    const usedmemory = ref(null);
    const {
      proxy
    } = getCurrentInstance();
    function getList() {
      proxy.$modal.loading("正在加载缓存监控数据，请稍候！");
      getCache().then(response => {
        proxy.$modal.closeLoading();
        cache.value = response.data;
        const commandstatsIntance = echarts.init(commandstats.value, "macarons");
        commandstatsIntance.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: [{
            name: "命令",
            type: "pie",
            roseType: "radius",
            radius: [15, 95],
            center: ["50%", "38%"],
            data: response.data.commandStats,
            animationEasing: "cubicInOut",
            animationDuration: 1000
          }]
        });
        const usedmemoryInstance = echarts.init(usedmemory.value, "macarons");
        usedmemoryInstance.setOption({
          tooltip: {
            formatter: "{b} <br/>{a} : " + cache.value.info.used_memory_human
          },
          series: [{
            name: "峰值",
            type: "gauge",
            min: 0,
            max: 1000,
            detail: {
              formatter: cache.value.info.used_memory_human
            },
            data: [{
              value: parseFloat(cache.value.info.used_memory_human),
              name: "内存消耗"
            }]
          }]
        });
      });
    }
    getList();
    return (_ctx, _cache) => {
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24,
          class: "card-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_hoisted_2]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_hoisted_5, _createElementVNode("td", _hoisted_6, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(cache).info.redis_version), 1)) : _createCommentVNode("", true)]), _hoisted_8, _createElementVNode("td", _hoisted_9, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(cache).info.redis_mode == "standalone" ? "单机" : "集群"), 1)) : _createCommentVNode("", true)]), _hoisted_11, _createElementVNode("td", _hoisted_12, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(cache).info.tcp_port), 1)) : _createCommentVNode("", true)]), _hoisted_14, _createElementVNode("td", _hoisted_15, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(cache).info.connected_clients), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_hoisted_17, _createElementVNode("td", _hoisted_18, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(cache).info.uptime_in_days), 1)) : _createCommentVNode("", true)]), _hoisted_20, _createElementVNode("td", _hoisted_21, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(cache).info.used_memory_human), 1)) : _createCommentVNode("", true)]), _hoisted_23, _createElementVNode("td", _hoisted_24, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(parseFloat(_unref(cache).info.used_cpu_user_children).toFixed(2)), 1)) : _createCommentVNode("", true)]), _hoisted_26, _createElementVNode("td", _hoisted_27, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(cache).info.maxmemory_human), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_hoisted_29, _createElementVNode("td", _hoisted_30, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(cache).info.aof_enabled == "0" ? "否" : "是"), 1)) : _createCommentVNode("", true)]), _hoisted_32, _createElementVNode("td", _hoisted_33, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(cache).info.rdb_last_bgsave_status), 1)) : _createCommentVNode("", true)]), _hoisted_35, _createElementVNode("td", _hoisted_36, [_unref(cache).dbSize ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(cache).dbSize), 1)) : _createCommentVNode("", true)]), _hoisted_38, _createElementVNode("td", _hoisted_39, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(cache).info.instantaneous_input_kbps) + "kps/" + _toDisplayString(_unref(cache).info.instantaneous_output_kbps) + "kps", 1)) : _createCommentVNode("", true)])])])])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "card-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_hoisted_41]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
              ref_key: "commandstats",
              ref: commandstats,
              style: {
                "height": "420px"
              }
            }, null, 512)])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "card-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_hoisted_43]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", {
              ref_key: "usedmemory",
              ref: usedmemory,
              style: {
                "height": "420px"
              }
            }, null, 512)])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};